import React, { useState, useEffect } from 'react';
import { useObservable } from 'react-use-observable';

import { Modal, Button, Input, Row, Col } from 'antd';

import type { IAffiliateOption } from 'v2/interfaces/affiliate/selectAffiliate';
import selectAffiliateService from 'v2/services/affiliate/selectAffiliate';

import { Header } from './Header';
import { List } from './List';

interface IProps {
  isOpen: boolean;
  onClose: () => void;
  selectedQuantity: number;
  selectedAffiliates: IAffiliateOption[];
  handleUncheckAll: () => void;
}

export const Dialog = ({ isOpen, selectedAffiliates, selectedQuantity, onClose, handleUncheckAll }: IProps) => {
  const [affiliates] = useObservable(() => selectAffiliateService.getAffiliates(), []);
  const [isLoadingAffiliates] = useObservable(() => selectAffiliateService.getIsLoading(), []);

  const [affiliateFilter, setAffiliateFilter] = useState('');

  useEffect(() => {
    return () => setAffiliateFilter('');
  }, []);

  const handleClose = () => {
    setAffiliateFilter('');
    onClose();
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setAffiliateFilter(e.target.value);
  };

  const filteredAffiliates = affiliateFilter
    ? (affiliates || []).filter(affiliate => {
        const lowerCaseName = affiliate.name.toLowerCase();
        const lowerCaseEmail = affiliate.email.toLowerCase();
        const lowerCaseFilter = affiliateFilter.toLowerCase();

        return lowerCaseName.includes(lowerCaseFilter) || lowerCaseEmail.includes(lowerCaseFilter);
      })
    : affiliates;

  return (
    <Modal
      open={isOpen}
      onCancel={handleClose}
      width='90vw'
      style={{ top: 20 }}
      title={
        <Row justify='space-between' gutter={[16, 16]}>
          <Col span={24}>{isLoadingAffiliates ? 'Carregando seus afiliados...' : 'Selecione seus afiliados'}</Col>
        </Row>
      }
      footer={
        <div className='flex flex-row justify-end gap-2'>
          <Button onClick={handleClose}>Fechar</Button>
          <Button type='primary' onClick={handleClose}>
            Confirmar ({selectedQuantity})
          </Button>
        </div>
      }
    >
      <div className='flex w-full flex-1 flex-col gap-4 overflow-hidden pt-0'>
        <Input
          placeholder='Procure seu afiliado pelo nome ou e-mail'
          onChange={handleSearchChange}
          value={affiliateFilter}
          autoFocus
          autoComplete='off'
        />

        <Header handleUncheckAll={handleUncheckAll} selectedQuantity={selectedQuantity} />
        <List
          selectedAffiliates={selectedAffiliates}
          affiliates={filteredAffiliates}
          selectedQuantity={selectedQuantity}
        />
      </div>
    </Modal>
  );
};
